import { render, staticRenderFns } from "./FilterPostV2.vue?vue&type=template&id=733c3264&scoped=true"
import script from "./FilterPostV2.vue?vue&type=script&lang=js"
export * from "./FilterPostV2.vue?vue&type=script&lang=js"
import style0 from "./FilterPostV2.vue?vue&type=style&index=0&id=733c3264&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "733c3264",
  null
  
)

export default component.exports